/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { AssetEdit } from "../../AssetEdit";
import { AssetEditMainPreview } from "./AssetEditMainPreview";

import "./AssetEditMain.scss";

export interface IAssetEditMainProps {
	className?: string;
	view: AssetEdit;
}

export const AssetEditMain: React.FC<IAssetEditMainProps> = ({ className, view }) => {
	const baseClass = BEM("edt-asset-edit-main");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<AssetEditMainPreview view={view} />
		</div>
	);
};
